/* eslint-disable import/no-anonymous-default-export */
import { Button, Form, notification, Select, Space } from "antd";
import { useForm } from "antd/lib/form/Form";
import moment from "moment";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { ActionResult } from "../../common/hooks/useApi";
import useEquiposAPI, { Equipo } from "../../equipos/useEquiposAPI";
import { EstadoInfraccion } from "../../infracciones/hooks/useInfraccionesAPI";
import useUsuariosAPI, { Usuario } from "../../usuarios/useUsuariosAPI";
import EstadisticasViewer, { EstadisticasViewerData } from "../components/EstadisticasViewer";
import useEstadisticasAPI from "../useEstadisticasAPI";
import { ExportOutlined, SearchOutlined } from '@ant-design/icons';
import _, { set } from "lodash";
import useUnidadesProduccionAPI, { UnidadProduccion } from "../../unidades-produccion/useUnidadesProduccionAPI";
import useCodigosInfraccionAPI, { CodigoInfraccion, formatDescripcionCodigoInfraccion } from "../../codigos-infraccion/hooks/useCodigosInfraccionAPI";
import Title from "antd/lib/typography/Title";

export type Proceso = ('RENOMBRADO' | 'VERIFICACION' | 'IMPRESION' | 'PRODUCCION' | 'PRODUCCION-FECHA-INFRACCION')

const Filters = styled.div`
display: grid;
grid-template-columns: repeat(auto-fit,minmax(120px, 1fr));
gap: 1rem;
align-items:top;
margin-bottom:1rem;
`

const FiltersButtons = styled.div`
display: flex;
justify-content: space-between;
`
export interface EstadisticasFilter {
    EquipoId?: number
    RenombradorId?: Number
    Year: number
    Month?: number
    Day?: number
    Proceso: Proceso
    UnidadProduccionId?: number
};

export default (props: {
    hideProcessFilter?: boolean
    hideUPFilter?: boolean
    hideEquipoFilter?: boolean
    hideRenombradorFilter?: boolean,
    initialFilters?: Partial<EstadisticasFilter>
}) => {
    const api = useEstadisticasAPI();
    const apiEquipos = useEquiposAPI();
    const apiRenombradores = useUsuariosAPI();
    const apiUnidadesProduccion = useUnidadesProduccionAPI();

    const [loading, setLoading] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [hideRenombradorFilter, setHideRenombradorFilter] = useState<boolean>()
    const [renombradoresResponse, setRenombradoresResponse] = useState<ActionResult<Usuario[]>>();
    const [unidadesProduccionResponse, setUnidadesProduccionResponse] = useState<ActionResult<UnidadProduccion[]>>();
    const [equiposResponse, setEquiposResponse] = useState<ActionResult<Equipo[]>>();
    const [estadisticasAnio, setEstadisticasAnio] = useState<EstadisticasViewerData[]>([]);
    const [estadisticasMes, setEstadisticasMes] = useState<EstadisticasViewerData[]>([]);
    const [estadisticasDia, setEstadisticasDia] = useState<EstadisticasViewerData[]>([]);
    const [unidadesSelect, setUnidadesSelect] = useState();

    // Codigo infraccion
    const codigoInfraccionApi = useCodigosInfraccionAPI();
    const options: [{ label: string; value: string }] = [{ label: "", value: "" }];
    const [codigosInfraccion, setCodigosInfraccion] = useState<CodigoInfraccion[]>([]);
    const [codigoInfraccionSeleccionado, setCodigoInfraccionSeleccionado] = useState<number | null>(null);
    const [keySelectCodigoInfraccion, setKeySelectCodigoInfraccion] = useState<any>(0);
    const [codigoInfraccionDescripcion, setCodigoInfraccionDescripcion] = useState<string>("");
    //------------------
    const [form] = useForm<EstadisticasFilter>();
    const [filters, setFilters] = useState<EstadisticasFilter>();
    const [selectedMonth, setSelectedMonth] = useState<number>();
    const [selectedYear, setSelectedYear] = useState<number>((new Date()).getFullYear());

    useEffect(() => {
        let filtersApiEquipo: any[] = [];
        let filtersApiUnidProd: any[] = [];
        if (process.env.REACT_APP_UNIDADES_PROD_PRUEBA && process.env.REACT_APP_UNIDADES_PROD_PRUEBA != '') {
            filtersApiEquipo = [`ConfiguracionProduccion/UnidadProduccion/Id in (${process.env.REACT_APP_UNIDADES_PROD_PRUEBA}) eq false`]
            filtersApiUnidProd = [`Id in (${process.env.REACT_APP_UNIDADES_PROD_PRUEBA}) eq false`]
        }

        if (unidadesSelect !== undefined) {
            filtersApiEquipo = [`ConfiguracionProduccion/UnidadProduccion/Id in (${unidadesSelect})`]
            apiEquipos.list({ $expand: ["ConfiguracionProduccion($expand=UnidadProduccion)"], $filter: filtersApiEquipo }).then(setEquiposResponse);
            setCodigosInfraccion([]);
            setCodigoInfraccionSeleccionado(null);
            setKeySelectCodigoInfraccion(Date.now());
            options.push({ label: "", value: "" });
            codigoInfraccionApi.codigoInfraccionPorUnidadProduccion(unidadesSelect).then(res => {
                if (res.data) {
                    setCodigosInfraccion(res.data);
                    res.data.forEach(element => {
                        options.push({ label: formatDescripcionCodigoInfraccion(element), value: element.id.toString() });
                    });
                }
            });
        }

        if (!props.hideEquipoFilter) apiEquipos.list({ $expand: ["ConfiguracionProduccion($expand=UnidadProduccion)"], $filter: filtersApiEquipo }).then(setEquiposResponse);

        if (!props.hideRenombradorFilter) apiRenombradores.list({ $filter: ["Role/Nombre eq 'Renombrador'"], $orderby: ["Apellido desc"] }).then(setRenombradoresResponse);

        if (!props.hideUPFilter) apiUnidadesProduccion.list({ $filter: filtersApiUnidProd }).then(setUnidadesProduccionResponse);

        form.setFieldsValue(props.initialFilters ?? {});

    }, [unidadesSelect]);

    const getYears = () => {
        const padding = 3;
        const actualYear = (new Date()).getFullYear();
        const arr = [];

        for (let i = actualYear - padding; i <= actualYear + padding; i++) {
            arr.push(i);
        }

        return arr;
    }

    const getDateFilter = (proceso?: Proceso) => {
        switch (proceso) {
            case 'RENOMBRADO':
                return "FechaRenombrado";
            case "VERIFICACION":
                return "FechaVerificacion"
            case "IMPRESION":
                return "FechaImpresionGenerada"
            case "PRODUCCION":
                return "CreatedAt"
            case "PRODUCCION-FECHA-INFRACCION":
                return "FechaHora"
            default:
                return "FechaHora";
        }
    }

    const getYAxis = (proceso?: Proceso) => {
        switch (proceso) {
            case 'RENOMBRADO':
                return [
                    { name: 'Renombradas', color: '#0288d1' }, { name: 'Efectivas', color: '#43a047' }, { name: 'Ilegibles', color: '#e53935' }
                ];
            case 'VERIFICACION':
                return [{ name: 'Verificadas', color: '#0288d1' }, { name: 'Efectivas', color: '#43a047' }, { name: 'Descartadas', color: '#e53935' }
                ];
            case 'IMPRESION':
                return [{ name: "Impresas", color: '#0288d1' }, { name: 'Enviadas', color: '#2a9b2a' }, { name: 'NoEnviadas', color: '#c57b26' }]

            case 'PRODUCCION':
                return [{ name: 'Capturas', color: '#c57b26' }, { name: "Renombradas", color: '#0288d1' }, { name: 'Impresas', color: '#2a9b2a' }, { name: 'Descartadas', color: '#e53935' }]

            case 'PRODUCCION-FECHA-INFRACCION':
                return [{ name: 'Capturas', color: '#c57b26' }, { name: "Renombradas", color: '#0288d1' }, { name: 'Efectivas', color: '#43a047' }, { name: 'Ilegibles', color: '#e53935' }, { name: 'Verificadas', color: '#3accac' }]
            default:
                return []
        }
    }

    const getEstadisticas = async (proceso: Proceso, $filter: string[], filterType: ('AÑO' | 'MES' | 'DIA')): Promise<EstadisticasViewerData[]> => {
        const filtersGroup: { [key: string]: string[] } = {};
        const estadisticas: EstadisticasViewerData[] = [];

        switch (proceso) {
            case 'RENOMBRADO':
                filtersGroup["Renombradas"] = [...$filter, ...[`Estado ne '${'PENDIENTE' as EstadoInfraccion}'`]];
                filtersGroup["Efectivas"] = [...$filter, ...[`Estado ne '${'PENDIENTE' as EstadoInfraccion}'`, "NoDistinguible eq false"]];
                filtersGroup["Ilegibles"] = [...$filter, ...[`Estado eq '${'RENOMBRADA' as EstadoInfraccion}'`, "NoDistinguible eq true"]];
                break;
            case 'VERIFICACION':
                filtersGroup["Verificadas"] = [...$filter, ...[`Estado in ('VERIFICADA','EXPORTADA','ACTA_GENERADA','IMPRESION_GENERADA','DESCARTADA')`]];
                filtersGroup["Efectivas"] = [...$filter, ...[`Estado in ('VERIFICADA','EXPORTADA','ACTA_GENERADA','IMPRESION_GENERADA')`]];
                filtersGroup["Descartadas"] = [...$filter, ...[`Estado eq 'DESCARTADA'`]];
                break;
            case 'IMPRESION':
                filtersGroup["Impresas"] = [...$filter, ...[`Estado  eq 'IMPRESION_GENERADA'`]];
                filtersGroup["Enviadas"] = [...$filter, ...[`ImpresionExcluida eq false`]];
                filtersGroup["NoEnviadas"] = [...$filter, ...[`ImpresionExcluida eq true`]];
                break;
            case 'PRODUCCION':
                filtersGroup["Renombradas"] = [...$filter, ...[`Estado ne '${'PENDIENTE' as EstadoInfraccion}'`]];
                filtersGroup["Impresas"] = [...$filter, ...[`Estado  eq 'IMPRESION_GENERADA'`]];
                filtersGroup["Descartadas"] = [...$filter, ...[`Estado eq 'DESCARTADA'`]];
                filtersGroup["Capturas"] = [...$filter, ...[]];
                break;

            case 'PRODUCCION-FECHA-INFRACCION':
                var codigoInfraccionQuery = "";

                if (codigoInfraccionSeleccionado) {
                    var codigoInfraccionEncontrado = codigosInfraccion.find(c => c.id == codigoInfraccionSeleccionado);
                    var descripcionCodigoInfraccion = 'Tipo infracción: ' + (codigoInfraccionEncontrado ? formatDescripcionCodigoInfraccion(codigoInfraccionEncontrado) : "Todos");
                    //filtersGroup[descripcionCodigoInfraccion] = [...$filter, ...[`CodigoInfraccionId eq ${codigoInfraccionSeleccionado}`]];
                    codigoInfraccionQuery = `and CodigoInfraccionId eq ${codigoInfraccionSeleccionado}`;
                }

                filtersGroup["Renombradas"] = [...$filter, ...[`Estado ne '${'PENDIENTE' as EstadoInfraccion}' ${codigoInfraccionQuery}`]];
                filtersGroup["Verificadas"] = [...$filter, ...[`Estado in ('VERIFICADA', 'IMPRESION_GENERADA', 'IMPRESION_EXCLUIDA') ${codigoInfraccionQuery}`]];// Se agrego las impresas ya que esas tb fueron verificadas
                filtersGroup["Descartadas"] = [...$filter, ...[`Estado in ('DESCARTADA')`]];
                filtersGroup["ImpGenExc"] = [...$filter, ...[`Estado in ('IMPRESION_GENERADA', 'IMPRESION_EXCLUIDA') ${codigoInfraccionQuery}`]];
                filtersGroup["Capturas"] = [...$filter, ...[]];
                filtersGroup["Efectivas"] = [...$filter, ...[`Estado ne '${'PENDIENTE' as EstadoInfraccion}' ${codigoInfraccionQuery}`, "NoDistinguible eq false"]];
                filtersGroup["Ilegibles"] = [...$filter, ...[`Estado eq '${'RENOMBRADA' as EstadoInfraccion}' ${codigoInfraccionQuery}`, "NoDistinguible eq true"]];
                filtersGroup["Pagadas"] = [...$filter, ...[`EstadoPago eq 'PAGADA' ${codigoInfraccionQuery}`]];
                filtersGroup["EnviadaEmail"] = [...$filter, ...[`ActaEnviadaEmail eq true ${codigoInfraccionQuery}`]];
                break;
        }



        for (const yName in filtersGroup) {
            const response = await api.getEstadisticasInfracciones({ $filter: filtersGroup[yName] }, filterType, getDateFilter(proceso));
            if (response.error) {
                notification.error({ message: "Error al consultar las estadísticas" });
                return [];
            }
            estadisticas.push({ yName, dataArr: response.data!.value! });
        }
        return estadisticas;

    };

    const onSubmit = async () => {
        const data = form.getFieldsValue();
        setLoading(true);

        const $filter: string[] = [
            data.EquipoId ? `EquipoId eq ${data.EquipoId}` : '',
            data.RenombradorId ? `LoteRenombrado/RenombradorAsignadoId eq ${data.RenombradorId}` : '',
            data.Year ? `year(${getDateFilter(data.Proceso)}) eq ${data.Year}` : '',
            data.UnidadProduccionId ? `Equipo/ConfiguracionProduccion/UnidadProduccionId eq ${data.UnidadProduccionId}` : ''
        ].filter(f => f != '');

        try {
            const estadisticasAnio = await getEstadisticas(data.Proceso, $filter, "AÑO");
            const estadisticasMes = data.Month ? await getEstadisticas(data.Proceso, [...$filter, ...[`month(${getDateFilter(data.Proceso)}) eq ${data.Month}`]], "MES") : [];
            const estadisticasDia = data.Day ? await getEstadisticas(data.Proceso, [...$filter, ...[`month(${getDateFilter(data.Proceso)}) eq ${data.Month}`, `day(${getDateFilter(data.Proceso)}) eq ${data.Day}`]], "DIA") : [];

            for (const index in estadisticasAnio) {
                estadisticasAnio[index] = {
                    yName: estadisticasAnio[index].yName,
                    dataArr: estadisticasAnio[index].dataArr.map((v) =>
                    ({
                        key: moment.monthsShort().map(m => m.toUpperCase())[v.key as number - 1],
                        value: v.value
                    }))
                }
            }

            setFilters(data);
            setEstadisticasAnio(estadisticasAnio);
            setEstadisticasMes(estadisticasMes);
            setEstadisticasDia(estadisticasDia);

        } catch (error) {
            notification.error({ message: "Error al cargar las estadísticas" });
        }
        setLoading(false);
    }

    const exportCsvEstadisticas = async () => {
        const data = form.getFieldsValue();
        const equipoId = form.getFieldsValue().EquipoId;

        if (!equipoId) {
            notification.warning({
                message: "Debe seleccionar un equipo antes de exportar..",
                placement: "bottomRight",
            });

            return;
        }

        if (data.Proceso != "PRODUCCION-FECHA-INFRACCION") {
            notification.warning({
                message: "La exportación solamente está habilitada para el proceso Fecha Infracción.",
                placement: "bottomRight",
            });

            return;
        }


        setLoading(true);

        const $filter: string[] = [
            data.EquipoId ? `EquipoId eq ${data.EquipoId}` : '',
            data.RenombradorId ? `LoteRenombrado/RenombradorAsignadoId eq ${data.RenombradorId}` : '',
            data.Year ? `year(${getDateFilter(data.Proceso)}) eq ${data.Year}` : '',
            data.UnidadProduccionId ? `Equipo/ConfiguracionProduccion/UnidadProduccionId eq ${data.UnidadProduccionId}` : ''
        ].filter(f => f != '');


        try {
            const estadisticasAnio = JSON.stringify(await getEstadisticas(data.Proceso, $filter, "AÑO"));
            const estadisticasMes = JSON.stringify(data.Month ? await getEstadisticas(data.Proceso, [...$filter, ...[`month(${getDateFilter(data.Proceso)}) eq ${data.Month}`]], "MES") : []);
            const estadisticasDia = JSON.stringify(data.Day ? await getEstadisticas(data.Proceso, [...$filter, ...[`month(${getDateFilter(data.Proceso)}) eq ${data.Month}`, `day(${getDateFilter(data.Proceso)}) eq ${data.Day}`]], "DIA") : []);
            const asd = await api.sendEstadisticasToExcel(estadisticasAnio, estadisticasMes, estadisticasDia, data.Month!, data.Year, data.EquipoId!);
        } catch (error) {
            notification.error({ message: "Error al cargar las estadísticas" });
        }
        setLoading(false);
    }

    return (
        <>
            <Form
                style={{ marginBottom: '1rem' }}
                form={form}
                onFinish={onSubmit}
                layout="vertical">
                <Filters>
                    <Form.Item
                        hidden={props.hideProcessFilter}
                        rules={[{
                            required: true,
                            message: 'Requerido'
                        }]}
                        style={{ marginBottom: 0 }} name="Proceso" label="Proceso">
                        <Select allowClear onChange={(value: Proceso) => value === "PRODUCCION" ? setHideRenombradorFilter(true) : setHideRenombradorFilter(false)}>
                            <Select.Option value={'RENOMBRADO' as Proceso} >Renombrado</Select.Option>
                            <Select.Option value={'VERIFICACION' as Proceso} >Verificación</Select.Option>
                            <Select.Option value={'IMPRESION' as Proceso} >Impresión</Select.Option>
                            <Select.Option value={'PRODUCCION' as Proceso} >Producción</Select.Option>
                            <Select.Option value={'PRODUCCION-FECHA-INFRACCION' as Proceso} >Fecha Infracción</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        hidden={props.hideUPFilter}
                        style={{ marginBottom: 0 }} name="UnidadProduccionId" label="U. producción">
                        <Select loading={!unidadesProduccionResponse} allowClear onChange={(e) => setUnidadesSelect(e)}>
                            {unidadesProduccionResponse?.data?.value.map(u =>
                                <Select.Option value={u.Id} key={u.Id}>{u.Nombre}</Select.Option>
                            )}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        hidden={props.hideEquipoFilter}
                        style={{ marginBottom: 0 }} name="EquipoId" label="Equipo">
                        <Select loading={!equiposResponse} allowClear options={equiposResponse?.data?.value.map(e => { return { value: e.Id, label: `${e.Nombre} ${e.ConfiguracionProduccion.UnidadProduccion.Nombre}` } })}>
                            {equiposResponse?.data?.value.filter(v => !filters?.UnidadProduccionId ? true : v.ConfiguracionProduccion.UnidadProduccionId == filters.UnidadProduccionId).map((e) =>
                                <Select.Option value={e.Id} key={e.Id}>{e.Nombre} ({e.ConfiguracionProduccion.UnidadProduccion.Nombre})</Select.Option>)
                            }
                        </Select>
                    </Form.Item>
                    <Form.Item
                        hidden={props.hideRenombradorFilter}
                        style={{ marginBottom: 0 }} name={"RenombradorId"} label="Renombrador">
                        <Select loading={!renombradoresResponse} disabled={hideRenombradorFilter} allowClear>
                            {renombradoresResponse?.data?.value.map((r) =>
                                <Select.Option value={r.Id} key={r.Id} >{r.Apellido} {r.Nombre}</Select.Option>)}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        rules={[{
                            required: true,
                            message: 'Requerido'
                        }]}
                        initialValue={selectedYear}
                        style={{ marginBottom: 0 }} name={"Year"} label="Año">
                        <Select onChange={(value) => setSelectedYear(value)} value={selectedYear} allowClear>
                            {getYears().map((y) => <Select.Option key={y} value={y}>{y}</Select.Option>)}
                        </Select>
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }} name={"Month"} label="Mes">
                        <Select onChange={(value) => setSelectedMonth(value)} allowClear>
                            {moment.months().map((m, i) => <Select.Option key={i} value={i + 1}>{m.toUpperCase()}</Select.Option>)}
                        </Select>
                    </Form.Item>
                    {selectedMonth &&
                        <Form.Item style={{ marginBottom: 0 }} name={"Day"} label="Día">
                            <Select allowClear>
                                {_.range(1, moment(`${selectedYear!}-${selectedMonth}`, "YYYY-M").daysInMonth() + 1).map((m, i) =>
                                    <Select.Option key={i} value={i + 1}>{m}</Select.Option>)}
                            </Select>
                        </Form.Item>}
                </Filters>

                <Title level={4}>Filtro por código de infracción</Title>
                <Select
                    key={keySelectCodigoInfraccion}
                    style={{ width: '100%', marginBottom: '1em' }}
                    onChange={(value, option) => { setCodigoInfraccionSeleccionado(value); console.log(codigosInfraccion) }}
                    defaultValue={null}
                    disabled={codigosInfraccion.length === 0}

                >
                    <Select.Option value={null}>Todos</Select.Option>
                    {codigosInfraccion.map((item) => (
                        <Select.Option key={item.id} value={item.id}>{formatDescripcionCodigoInfraccion(item)}</Select.Option>
                    ))}
                </Select>

                <FiltersButtons style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button loading={loading} type='primary' htmlType="submit" icon={<SearchOutlined />} >Filtrar</Button>
                    {selectedMonth && (
                        <Button loading={loadingExcel} type='primary' onClick={exportCsvEstadisticas} icon={<ExportOutlined />} >Exportar excel</Button>
                    )}
                </FiltersButtons>

            </Form>

            <Space size={20} direction='vertical' style={{ width: '100%' }} >



                <EstadisticasViewer
                    title={`Estadísticas de ${filters?.Year ?? (new Date()).getFullYear()} ${filters?.Proceso ? `(${_.startCase(_.toLower(filters.Proceso))})` : ''}`}
                    xAxis={moment.monthsShort().map(m => m.toUpperCase())}
                    yAxis={getYAxis(filters?.Proceso)}
                    data={estadisticasAnio}
                    tooltipLabelFormatter={(label) => `${_.upperFirst(moment(label, "MMM").format("MMMM"))} ${filters?.Year}`}
                />
                {filters?.Year && filters.Month &&
                    <EstadisticasViewer
                        width={1000}
                        title={`Estadísticas de ${moment.months()[filters.Month - 1]} ${filters?.Proceso ? `(${_.startCase(_.toLower(filters.Proceso))})` : ''}`}
                        xAxis={filters?.Year && filters.Month ? _.range(1, moment(`${filters.Year!}-${filters.Month}`, "YYYY-M").daysInMonth() + 1) : []}
                        yAxis={getYAxis(filters?.Proceso)}
                        data={estadisticasMes}
                        tooltipLabelFormatter={(label) => `${_.upperFirst(moment(`${label}-${filters.Month}-${filters.Year}`, "D-M-YYYY").format("dddd D [de] MMMM"))}`}
                    />}

                {filters?.Year && filters.Month && filters.Day &&
                    <EstadisticasViewer
                        width={1000}
                        title={`Estadísticas del día ${filters.Day} por hora ${filters?.Proceso ? `(${_.startCase(_.toLower(filters.Proceso))})` : ''}`}
                        xAxis={filters?.Year && filters.Month && filters.Day ? _.range(0, 24) : []}
                        yAxis={getYAxis(filters?.Proceso)}
                        data={estadisticasDia}
                        tooltipLabelFormatter={(label) => `${_.upperFirst(moment(`${label}-${filters.Day}-${filters.Month}-${filters.Year}`, "h-D-M-YYYY").format("dddd D, H[hs]"))}`}
                    />}



            </Space></>
    );
};